import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import PaperDraggable from "../../../../../components/PaperDraggable";
import { FormProvider, useForm } from "react-hook-form";
import Stepper from "./Stepper";
import { formatarMonetárioParaNúmero } from "../../../../../helpers/masks";
import { useMutation } from "react-query";
import axiosClient from "../../../../../lib/axios";
import { enqueueSnackbar } from "notistack";
import moment from "moment";
import DialogResetForm from "./Stepper/DialogResetForm";
import { useState } from "react";

export default function DialogIncluirLancamento({
    open,
    handleClose
}: DialogIncluirLancamentoProps) {

    const [openDialogResetForm, setOpenDialogResetForm] = useState(false)

    //Querys e mutations
    const { mutate: criarLancamento } = useMutation({
        mutationKey: 'solicitar-criacao-lancamento-caixa-banco',
        mutationFn: (inputs: any) => axiosClient.post("/financeiro/caixa-bancos/cadastrar-lancamento", inputs, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }),
        onError: (error) => {
            console.error(error)
            enqueueSnackbar('Erro ao cadastrar lançamento!', { variant: 'error' });
        },
        onSuccess: () => {
            enqueueSnackbar(`Lançamento criado com sucesso!`, { variant: 'success' });
            setOpenDialogResetForm(true)
        },
        onSettled: () => setValue('isLoadingIncluirLancamento', false)
    })

    const handleNextStep = () => {
        const stepper = getValues('stepper')
        setValue('stepper', stepper + 1)
    }

    const handleBackStep = () => {
        const stepper = getValues('stepper')
        setValue('stepper', stepper - 1)
    }


    const onSubmit = (data: any) => {
        setValue('isLoadingIncluirLancamento', true)
    
        const params = {
            //STEP01
            conta_bancaria_codigo: data.step01.conta_bancaria.codigo,
            contra_partida_codigo: data.step01.contra_partida.codigo_contabil,
            ...(data.step01.contra_partida.centro_custo && {
                contra_partida_custo: data.step01.contra_partida.centro_custo.id,
            }),
            data_lancamento: moment(data.step01.data_lancamento).format("YYYY-MM-DD"),
            valor_lancamento: formatarMonetárioParaNúmero(data.step01.valor),
            debito_credito: data.step01.debito_credito === 'D' ? 'B' : 'C',
            
            //STEP02
            ...(data.step02.historico.codigo && {
                historico_codigo: data.step02.historico.codigo,
            }),
            ...(data.step02.historico.descricao && {
                historico_descricao: data.step02.historico.descricao,
            }),
            numero_documento: data.step02.nr_documento === "" ? 0 : Number(data.step02.nr_documento),
            beneficiario: data.step02.beneficiario === "" ? null : data.step02.beneficiario
        }
        criarLancamento(params)
    }

    const defaultValuesForm = {
        isLoadingIncluirLancamento: false,
        stepper: 0,
        step01: {
            conta_bancaria: '',
            contra_partida: '',
            data_lancamento: null,
            debito_credito: '',
            valor: ''
        },
        step02: {
            nr_documento: '',
            historico: '',
            publico: '',
            beneficiario : ''
        },
        funcoesAux: {
            onNext: handleNextStep,
            onBack: handleBackStep,
            onCloseModal: handleClose,
            onSubmit: onSubmit
        },
    }

    const methods = useForm({ defaultValues: defaultValuesForm })
    const { getValues, setValue, } = methods

    return (
        <FormProvider {...methods}>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth={'md'}
                fullWidth
                PaperComponent={PaperDraggable}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Criar lançamento</DialogTitle>
            
                <DialogContent>
                    <Stepper />
                </DialogContent>

                <DialogActions>
                    <Button
                        variant="text"
                        onClick={handleClose}
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>

            {
                openDialogResetForm && (
                    <DialogResetForm
                        open={openDialogResetForm}
                        handleConfirm={() => {
                            setOpenDialogResetForm(false)
                            methods.reset(defaultValuesForm)
                        }}
                        handleClose={() => {
                            setOpenDialogResetForm(false)
                            handleClose()
                        }}
                    />
                )
            }
        </FormProvider>
    )
}

export interface DialogIncluirLancamentoProps {
    open: boolean;
    handleClose: () => void
}
